module.exports = __webpack_public_path__ + "img/box_lng_grey.df5f3fb9.png";